import { render, staticRenderFns } from "./DecidedApprovalsFilter.vue?vue&type=template&id=243a45d9&"
import script from "./DecidedApprovalsFilter.vue?vue&type=script&lang=js&"
export * from "./DecidedApprovalsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports